"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _iconBase = _interopRequireDefault(require("../icon-base"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var AdpCloseThin = function AdpCloseThin(props) {
  return _react.default.createElement(_iconBase.default, props, _react.default.createElement("g", null, _react.default.createElement("path", {
    d: "M36.69 1030.16L.124 993.594 989.25 4.468l36.566 36.566L36.69 1030.16zm989.016-36.532l-36.566 36.566L.014 41.068 36.58 4.502l989.126 989.126z"
  })));
};
AdpCloseThin.defaultProps = {
  viewBox: '0 0 1025.816 1043.776',
  height: '1em',
  width: '0.9828em'
};
AdpCloseThin.displayName = 'AdpCloseThin';
var _default = AdpCloseThin;
exports.default = _default;